import React from "react";
import "./errorpage.css"
import Error404Icon from "../../assets/img/svg/x404errorimage.svg";
import { useNavigate } from "react-router-dom";

const Error404Page = () => {
  const navigate = useNavigate();
  	const handleNavigation = (route) => {
		navigate(route);
	};
  return (
    <div className="error-pages-container">
      <img src={Error404Icon} alt="404 Error"></img>
      <h1>Oh no..Page Not Found</h1>
      <p>
        <strong>Error 404 :</strong> The page you were looking for seems to have
        gone missing.
      </p>
      <button  className="error-accept-button" onClick={() => handleNavigation("/")}>Back To Home Page</button>
    </div>
  );
};

export default Error404Page;
